module.exports = __webpack_public_path__ + "img/2.a7b3d602.png";